module.exports = __webpack_public_path__ + "img/box1.2f60c6d4.png";